import { DateUtilsService } from 'src/app/services/date-utils.service';
import { NumberUtilsService } from 'src/app/services/number-utils.service';
import { BulkLoadItemDto } from 'src/generated-sources/openapi/bulk-load-service/bulk-load-file';
import { TableConfig } from 'src/app/shared/components/generic-table';

export type ColumnKeys = keyof BulkLoadItemDto | '_action';

export const PROCESSED_FILES_NO_DATA_MESSAGE = $localize`:@@noTrackingRecordProcessedFilesFound:No se han encontrado archivos de carga.`;

export const getProcessedTableConfig = (
  dateUtilsService: DateUtilsService,
  numberUtilsService: NumberUtilsService,
): TableConfig<BulkLoadItemDto, ColumnKeys> => ({
  columns: [
    {
      title: $localize`Fecha de Carga`,
      id: 'uploadDate',
      hasCustomContent: false,
      sortable: true,
      minWidth: '120px',
      textAlign: 'center',
      getValue: (value) => dateUtilsService.dateToUserTimezone(value.uploadDate),
    },
    {
      title: $localize`Usuario`,
      id: 'userName',
      hasCustomContent: false,
      sortable: true,
      width: '1.5fr',
      minWidth: '100px',
      textAlign: 'center',
      getValue: (value) => value.userName,
    },
    {
      title: $localize`Archivo`,
      id: 'fileName',
      hasCustomContent: true,
      sortable: true,
      width: '1.5fr',
      minWidth: '200px',
      textAlign: 'center',
    },
    {
      title: $localize`Documentos Enviados`,
      id: 'totalRegistries',
      hasCustomContent: false,
      sortable: true,
      minWidth: '120px',
      textAlign: 'center',
      getValue: (value) => {
        const inProcess = value.status === 'PROCESSING';
        const quantity = inProcess || !value?.totalRegistries ? 0 : value.totalRegistries;
        return numberUtilsService.thousandsFormat(quantity);
      },
    },
    {
      title: $localize`Documentos Rechazados`,
      id: 'errorCount',
      hasCustomContent: false,
      sortable: true,
      minWidth: '120px',
      textAlign: 'center',
      getValue: (value) => {
        const inProcess = value.status === 'PROCESSING';
        const quantity = inProcess || !value?.errorCount ? 0 : value.errorCount;
        return numberUtilsService.thousandsFormat(quantity);
      },
    },
    {
      title: $localize`Estado de Procesamiento`,
      id: 'status',
      hasCustomContent: true,
      sortable: true,
      minWidth: '180px',
      textAlign: 'center',
    },
    {
      title: $localize`Descargar Archivo`,
      id: '_action',
      hasCustomContent: true,
      width: '120px',
      textAlign: 'center',
    },
  ],
  trackByProp: ['id'],
  rowIdFn: (row: BulkLoadItemDto) => String(row.id)
});

export const processedTableConfig = getProcessedTableConfig(
  {} as DateUtilsService,
  {} as NumberUtilsService,
);
